import { render, staticRenderFns } from "./ExamPsdDownLoad.vue?vue&type=template&id=72f0b87b&scoped=true"
import script from "./ExamPsdDownLoad.vue?vue&type=script&lang=js"
export * from "./ExamPsdDownLoad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f0b87b",
  null
  
)

export default component.exports